var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnfoldMoreMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24,0c-7.7197266,0-14,6.2802734-14,14v20c0,7.7197266,6.2802734,14,14,14s14-6.2802734,14-14V14 C38,6.2802734,31.7197266,0,24,0z M36,34c0,6.6166992-5.3828125,12-12,12s-12-5.3833008-12-12V14c0-6.6166992,5.3828125-12,12-12 s12,5.3833008,12,12V34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,37.5859375l-5.2929688-5.2929688l-1.4140625,1.4140625l6,6C23.4882812,39.9023438,23.7441406,40,24,40 s0.5117188-0.0976562,0.7070312-0.2929688l6-6l-1.4140625-1.4140625L24,37.5859375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2929688,8.2929688l-6,6l1.4140625,1.4140625L24,10.4140625l5.2929688,5.2929688l1.4140625-1.4140625l-6-6 C24.3164062,7.9023438,23.6835938,7.9023438,23.2929688,8.2929688z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfoldMoreMedium);
export default __webpack_public_path__ + "static/media/unfold-more--medium.ba295bba1285d26f253dcac35584a788.svg";
export { ForwardRef as ReactComponent };